import { forwardRef, useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { cn } from '@/lib/cn';
import { Input } from './Input';
import type { InputProps } from './Input';

export interface PasswordInputProps extends Omit<InputProps, 'type' | 'trailing'> {
  /** Hides the padlock when the surrounding layout already implies a password. */
  showLockIcon?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { showLockIcon = true, icon, autoComplete = 'current-password', ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);
  const ToggleIcon = visible ? EyeOff : Eye;

  return (
    <Input
      ref={ref}
      type={visible ? 'text' : 'password'}
      autoComplete={autoComplete}
      icon={icon ?? (showLockIcon ? Lock : undefined)}
      {...rest}
      trailing={
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-pressed={visible}
          aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
          title={visible ? 'Ocultar senha' : 'Mostrar senha'}
          className={cn(
            'flex size-9 items-center justify-center rounded-sm text-text-muted',
            'transition-colors duration-150 ease-out-soft hover:bg-surface-3 hover:text-text',
            "relative after:absolute after:left-1/2 after:top-1/2 after:size-11 after:-translate-x-1/2 after:-translate-y-1/2 after:content-['']",
          )}
        >
          <ToggleIcon aria-hidden="true" className="size-4" />
        </button>
      }
    />
  );
});
